'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgArrowUpCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M6 0c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6zm0 1.286A4.72 4.72 0 001.286 6 4.72 4.72 0 006 10.714 4.72 4.72 0 0010.714 6 4.72 4.72 0 006 1.286zm.032 1.285c.274 0 .496.193.496.43v4.936l.768-.665a.552.552 0 01.702 0 .392.392 0 010 .61L6.36 9.301A.536.536 0 016 9.43a.536.536 0 01-.36-.126L4.002 7.88a.392.392 0 010-.609.553.553 0 01.703 0l.83.72v-4.99c0-.238.223-.43.497-.43z", id: "Arrow-up-circle_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", transform: "rotate(180 6 6)", xlinkHref: "#Arrow-up-circle_svg__a" })))));
}

module.exports = SvgArrowUpCircle;
//# sourceMappingURL=ArrowUpCircle.js.map
